import { Benefit } from '@/components/blocks/Benefits/parts/Benefit';
import { DpContainer } from '@/components/blocks/DpContainer';
import { DrawerBenefit } from '@/components/blocks/DpDrawerBenefit';
import {
	BenefitsDistContainerItemSX,
	BenefitsDistFrameSX,
	BenefitsDistTitleSX,
} from '@/components/blocks/DpLibrary/DpBenefitsDistribuidor/style';
import { DpH4 } from '@/components/blocks/DpLibrary/DpH4';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { combineSX } from '@/utils/combineSX';
import { Grid, SxProps } from '@mui/material';
import { useState } from 'react';

interface BenefitProps {
	framesx?: SxProps;
}

export const DpBenefitsDistribuidor: React.FC<BenefitProps> = ({ framesx }) => {
	const isTablet = useIsMobile();
	const [openDrawer, setOpenDrawer] = useState<
		| {
				title: string;
				emsName: string;
		  }
		| undefined
	>(undefined);

	const handleOpenDrawer = (title: string, emsName: string) => () => {
		setOpenDrawer({ title, emsName });
	};

	const handleCloseDrawer = () => {
		setOpenDrawer(undefined);
	};

	return (
		<DpContainer
			framesx={combineSX([BenefitsDistFrameSX, ...(Array.isArray(framesx) ? framesx : [framesx])])}
		>
			<Grid container>
				{!isTablet ? (
					<Grid xs={12} item>
						<DpH4 sx={BenefitsDistTitleSX}>{'BENEFICIOS DE COMPRAR EN DPORTENIS'}</DpH4>
					</Grid>
				) : null}
				<Grid
					item
					container
					xs={12}
					sx={{
						...BenefitsDistContainerItemSX(isTablet),
						display: 'grid',
						gridTemplateColumns: 'repeat(2,1fr)',
						gap: '17px',
						'@media(min-width:960px)': {
							gridTemplateColumns: 'repeat(4,1fr)',
						},
					}}
				>
					<Benefit
						title="30 días para devoluciones"
						description="En línea o en tienda"
						imgSrc="EmeraldSAS/images/promotion/devolucion.png"
						isTablet={isTablet}
						onClick={handleOpenDrawer(
							'Cambios y Devoluciones',
							'DrawerReturnsExchangesInformative'
						)}
					/>

					<Benefit
						title="Envío gratis a todo México"
						description="en compras mayores a $999"
						imgSrc="EmeraldSAS/images/promotion/envio-gratis.png"
						isTablet={isTablet}
						onClick={handleOpenDrawer('Entregas y Envíos', 'DrawerDeliveriesShipmentsInformative')}
					/>

					<Benefit
						title="Compra en línea y paga en efectivo"
						description="OXXO y BBVA"
						imgSrc="EmeraldSAS/images/promotion/pago-linea.png"
						isTablet={isTablet}
						onClick={handleOpenDrawer('Formas de Pago', 'DrawerPaymentMethodsInformative')}
					/>

					<Benefit
						title="Hasta 9 MSI con tarjetas de crédito"
						description="Pagando con tarjetas participantes*."
						imgSrc="EmeraldSAS/images/promotion/msi.png"
						isTablet={isTablet}
						onClick={handleOpenDrawer('¿Como comprar?', 'DrawerHowToBuy')}
					/>
				</Grid>
			</Grid>
			<DrawerBenefit
				open={!!openDrawer}
				title={openDrawer?.title || ''}
				emsName={openDrawer?.emsName || ''}
				onClose={handleCloseDrawer}
			/>
		</DpContainer>
	);
};
